// extracted by mini-css-extract-plugin
export default {"main":"aboutUs_main__uOSTU","title":"aboutUs_title__0TbiM","cards":"aboutUs_cards__PI+px","divType":"aboutUs_divType__vlIz1","divType2":"aboutUs_divType2__dzec4"};